import { Autocomplete, Box, TextField } from '@mui/material';
import LuxuryProCatalogThumb from './LuxuryProCatalogThumb';

export default function LuxuryProCatalogPicker({ catalogs, valueId, onChange, disabled }) {
  const value = catalogs.find((c) => String(c.id) === String(valueId)) || null;

  return (
    <Autocomplete
      disabled={disabled}
      size="small"
      sx={{ minWidth: 280, flex: 1 }}
      options={catalogs}
      value={value}
      onChange={(_, catalog) => onChange(catalog ? catalog.id : '')}
      getOptionLabel={(c) => c.name || ''}
      isOptionEqualToValue={(a, b) => String(a?.id) === String(b?.id)}
      noOptionsText="Không có catalog"
      renderOption={(props, catalog) => (
        <Box
          component="li"
          {...props}
          key={catalog.id}
          sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1, px: 1 }}
        >
          <LuxuryProCatalogThumb src={catalog.thumbnail} alt={catalog.name} />
          <Box component="span" sx={{ fontSize: 13, lineHeight: 1.35, flex: 1 }}>
            {catalog.name}
          </Box>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Chọn loại fulfill (ảnh + tên)"
          InputProps={{
            ...params.InputProps,
            startAdornment: value?.thumbnail ? (
              <>
                <LuxuryProCatalogThumb
                  src={value.thumbnail}
                  sx={{ width: 36, height: 36, borderRadius: 0.5, mr: 1, ml: 0.5 }}
                />
                {params.InputProps.startAdornment}
              </>
            ) : (
              params.InputProps.startAdornment
            ),
          }}
        />
      )}
    />
  );
}
